module.exports = __webpack_public_path__ + "img/s-co2.9e580993.png";